import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import Context from 'frontools/core/Context';

export default class ImageSizeManager extends AbstractDispatcher {
    
    private _wrap           : HTMLElement;

    private _maxWidth        : number;
    private _maxHeight       : number;
    private _ratio           : number;

    private _firstLoad       : boolean = true;

    private _elements         : NodeListOf<HTMLElement>;

    constructor() {
        super();        
        this._wrap = document.querySelector('.wrap') as HTMLElement;
        
        this.parseElements();
    }

    public parseElements() {
        this._elements = document.querySelectorAll('[data-image-resize]') as NodeListOf<HTMLElement>;
        this.onResize();
    }

    /**  
     * onResize - Resize handler
     * 
     */
    public onResize() {
        this._maxWidth = parseFloat(getComputedStyle(this._wrap).width) - (parseFloat(getComputedStyle(this._wrap).paddingLeft)*2);
        this._maxHeight = (Math.round(Context.getInstance().viewport.height) * .90) - 200;

        this.resizeImages(this._elements);    
    }

    public resizeImages(elements) {
        for (let j = 0; j < elements.length; j++) {
            let el = elements[j],
            ratio = Number(el.getAttribute('data-image-resize'));

            if (this._firstLoad) TweenMax.set(el, {opacity:0});

            let height = this._maxHeight,
                width = Math.round(this._maxHeight / ratio);

            if (width > this._maxWidth) {
                width = this._maxWidth;
                height = this._maxWidth * ratio;
            }   
            
            el.style.height = `${height}px`;
            el.style.width = `${width}px`;

            TweenMax.to(el, 0.4,{opacity:1});

        }

        if (this._firstLoad) this._firstLoad = false;
    }

    
}